import angular from 'angular';

declare var LtFramework: lt.Static;

// let basePath: string = 'https://mnqaapp07z4.ltfinc.net:10255/myaccount/api';
let basePath: string;
if (typeof(LtFramework.global.lt) !== 'undefined'
	&& typeof(LtFramework.global.lt.api) !== 'undefined'
	&& LtFramework.global.lt.api != null
	&& LtFramework.global.lt.api.account != null) {

	basePath = LtFramework.global.lt.api.account;
} else {
	// basePath = '/api/myaccount';
	basePath = 'https://myaccountst.lifetimefitness.com/myaccount/api';
}

const muxBasePath = `${LtFramework.global.lt.api.apimUrl}mux/member-process-api`;

// SSO ID needs to be in the header of every request to My Account
const globalHeaders = {
	'X-LTF-SSOID': (): string => {
		const store = LtFramework.getStore('ProfileStore') as lt.IProfileStore;
		return store.getInitialData().sso;
	}
};

const apimHeaders = {
	'X-LTF-SSOID': (): string => {
		const store = LtFramework.getStore('ProfileStore') as lt.IProfileStore;
		return store.getInitialData().sso;
	},
	'Ocp-Apim-Subscription-Key': window.lt.api.apimKey
};

angular.module('ltt.myaccount.api', ['ngResource'])

	.constant('MyAccountApiBasePath', basePath)

	.factory('ClubVisitResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IClubVisitResource => {
		return $resource(`${basePath}/member/clubvisits`, {}, {
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IClubVisitResource;
	}])

	.factory('MembershipResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IMembershipResource => {
		return $resource<MyAccountApi.IMembership>(`${basePath}/membership`, {}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('RecurringProductResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IRecurringProductResource => {
		return $resource<MyAccountApi.IRecurringProduct>(`${muxBasePath}/v1/member/:memberId/subscription`, {memberId: '@memberId'}, {
			query: {
				headers: apimHeaders,
				isArray: true,
				method: 'GET'
			} as ng.resource.IActionDescriptor,
			// accepts a bool magazineOptIn parameter
			optInExperienceLife: {
				url: `${basePath}/recurringproducts/magazine`,
				headers: $.extend(true, {'Content-Type': 'application/x-www-form-urlencoded'}, globalHeaders),
				isArray: false,
				method: 'POST',
				// this transformRequest function converts the JSON request body created by ngResource to form params
				transformRequest: (data: object) => {
					if (data === undefined) {
						return data;
					}

					const clonedData = $.extend(true, {}, data);
					for (const property in clonedData) {
						if (property.substr(0, 1) === '$') {
							delete clonedData[property];
						}
					}
					return $.param(clonedData);
				}
			} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IRecurringProductResource;
	}])

	.factory('SessionPackageResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ISessionPackageResource => {
		return $resource<MyAccountApi.ISessionPackage>(`${basePath}/sessions`, {}, {
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor,
			get: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('CountryResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ICountryResource => {
		return $resource<MyAccountApi.ICountry>(`${basePath}/countries`, {}, {
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('UserResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserResource => {
		return $resource<MyAccountApi.IUser>(`${basePath}/user`, {}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('UserAccountResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserAccountResource => {
		const servicePath = `${basePath}/useridentity/account`;

		return $resource<MyAccountApi.IUserAccount>(servicePath, {}, {
			activate: {
				url: `${servicePath}/activate`,
				headers: globalHeaders,
				isArray: false,
				method: 'POST'
			} as ng.resource.IActionDescriptor,
			create: {
				url: `${servicePath}/create`,
				headers: globalHeaders,
				isArray: false,
				method: 'POST'
			} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IUserAccountResource;
	}])

	.factory('UserIdentityResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserIdentityResource => {
		const servicePath = `${basePath}/useridentity`;
		return $resource(servicePath, {}, {
			validate: {
				url: `${servicePath}/validate`,
				headers: globalHeaders,
				isArray: false,
				method: 'POST'
			} as ng.resource.IActionDescriptor,
			save: {
				url: `${servicePath}/resendActivation`,
				headers: globalHeaders,
				isArray: false,
				method: 'POST'
			} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IUserIdentityResource;
	}])

	.factory('UserAddressResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserAddressResource => {
		return $resource<MyAccountApi.IUserAddress>(`${basePath}/addresses/:contactMethodId`, {contactMethodId: '@contactMethodId'}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor,
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor,
			create: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor,
			save: {headers: globalHeaders, isArray: false, method: 'PUT'} as ng.resource.IActionDescriptor,
			delete: {headers: globalHeaders, isArray: false, method: 'DELETE'} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IUserAddressResource;
	}])

	.factory('UserPhoneNumberResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserPhoneNumberResource => {
		return $resource<MyAccountApi.IUserPhoneNumber>(`${basePath}/telephones/:contactMethodId`, {contactMethodId: '@contactMethodId'}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor,
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor,
			create: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor,
			save: {headers: globalHeaders, isArray: false, method: 'PUT'} as ng.resource.IActionDescriptor,
			delete: {headers: globalHeaders, isArray: false, method: 'DELETE'} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IUserPhoneNumberResource;
	}])

	.factory('UserEmailResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserEmailResource => {
		return $resource<MyAccountApi.IUserEmail>(`${basePath}/user/email`, {}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor,
			save: {headers: globalHeaders, isArray: false, method: 'PUT'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('EmergencyContactsResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IEmergencyContactsResource => {
		return $resource<MyAccountApi.IEmergencyContacts>(`${basePath}/emergencycontacts`, {}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor,
			save: {headers: globalHeaders, isArray: false, method: 'PUT'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('UserPasswordResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserPasswordResource => {
		return $resource<MyAccountApi.IUserPassword>(`${basePath}/user/password`, {}, {
			save: {headers: globalHeaders, isArray: false, method: 'PUT'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('UserPasswordTokenResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserPasswordTokenResource => {
		return $resource<MyAccountApi.IUserPasswordToken>(`${basePath}/useridentity/updatePasswordToken`, {}, {
			save: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('CreditCardTypeResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ICreditCardTypeResource => {
		return $resource<MyAccountApi.ICreditCardType>(`${basePath}/paymentaccounts/cardTypeVals`, {}, {
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('CreditCardPurposeResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ICreditCardPurposeResource => {
		return $resource<MyAccountApi.ICreditCardPurpose>(`${basePath}/paymentaccounts/cardPurposeVals`, {}, {
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('AgreementResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IAgreementResource => {
		return $resource<MyAccountApi.IAgreement>(`${basePath}/agreement/new/:contractTypeId/:paymentType`, {}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('SignedAgreementResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ISignedAgreementResource => {
		return $resource<MyAccountApi.IAgreement>(`${muxBasePath}/v1/member/:memberId/agreement/:agreementId?agreementSource=:agreementType`, {}, {
			get: {headers: apimHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('NonMemberSignedAgreementResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ISignedAgreementResource => {
		return $resource<MyAccountApi.IAgreement>(`${muxBasePath}/v1/party/:partyId/agreement/:agreementId?agreementSource=:agreementType`, {}, {
			get: {headers: apimHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('UserPermissionsResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserPermissionsResource => {
		return $resource<MyAccountApi.IUserPermissions>(`${basePath}/permissions`, {}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('ForgotPasswordResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IForgotPasswordResource => {
		return $resource<MyAccountApi.IForgotPassword>(`${basePath}/useridentity/resetPasswordToken`, {}, {
			submit: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IForgotPasswordResource;
	}])

	.factory('ForgotUsernameResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IForgotUsernameResource => {
		return $resource<MyAccountApi.IForgotUsername>(`${basePath}/useridentity/recoverUsername`, {}, {
			submit: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IForgotUsernameResource;
	}])

	.factory('UserPaymentAccountsResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IUserPaymentAccountsResource => {
		return $resource<MyAccountApi.IUserPaymentAccount>(`${basePath}/paymentaccounts/:accountId`, {accountId: '@accountId'}, {
			get: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor,
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor,
			create: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor,
			save: {headers: globalHeaders, isArray: false, method: 'PUT'} as ng.resource.IActionDescriptor,
			delete: {headers: globalHeaders, isArray: false, method: 'DELETE'} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IUserPaymentAccountsResource;
	}])

	.factory('TransactionHistoryResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ITransactionHistoryResource => {
		return $resource<MyAccountApi.ITransactionHistory>(`${basePath}/tran`, {}, {
			query: {headers: globalHeaders, isArray: false, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('TransactionResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ITransactionResource => {
		return $resource<MyAccountApi.ITransaction>(`${basePath}/tran`, {}, {
			get: {headers: globalHeaders, isArray: false, method: 'POST'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('TransactionTypeResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.ITransactionTypeResource => {
		return $resource<MyAccountApi.ITransactionType>(`${basePath}/tran/purchasetypes`, {}, {
			query: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('ResourceKeyResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IResourceKeyResource => {
		return $resource<MyAccountApi.IResourceKey>(`${basePath}/user/keys`, {}, {
			get: {headers: globalHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('MemberDetailsResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IMemberDetailsResource => {
		const servicePath = `${basePath}/membership`;
		return $resource<MyAccountApi.IMemberDetails>(servicePath, {}, {
			query: {
				headers: globalHeaders,
				url: `${servicePath}/memberdetails`,
				isArray: true,
				method: 'GET'
			} as ng.resource.IActionDescriptor,
			sign: {
				headers: globalHeaders,
				url: `${servicePath}/signpartnerauth`,
				isArray: false,
				method: 'POST'
			} as ng.resource.IActionDescriptor,
			term: {
				headers: globalHeaders,
				url: `${servicePath}/termpartnerauth`,
				isArray: false,
				method: 'POST'
			} as ng.resource.IActionDescriptor
		}) as MyAccountApi.IMemberDetailsResource;
	}])

	.factory('AgreementHistoryResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.IAgreementHistoryResource => {
		return $resource<MyAccountApi.IAgreementHistory>(`${muxBasePath}/v1/member/:memberId/agreement`, {memberId: '@memberId'}, {
			query: {headers: apimHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}])

	.factory('NonMemberAgreementHistoryResource', ['$resource', ($resource: ng.resource.IResourceService): MyAccountApi.INonMemberAgreementHistoryResource => {
		return $resource<MyAccountApi.IAgreementHistory>(`${muxBasePath}/v1/party/:partyId/agreement`, {partyId: '@partyId'}, {
			query: {headers: apimHeaders, isArray: true, method: 'GET'} as ng.resource.IActionDescriptor
		});
	}]);
